<template>
  <v-form
    @input="(event) => $emit('setIsFormValid', event)"
    @submit.prevent="(event) => $emit('submit', event)"
    class="commit-data"
  >
    <textInput
      @input="(event) => $emit('setTitle', event)"
      label="Change Summary Title"
      placeholder="Summary Title"
      :value="title"
      width="300px"
      :required="!disabled"
      validate-on-blur
      :disabled="disabled"
    />
    <textInput
      @input="(event) => $emit('setDetails', event)"
      label="Optional Details"
      placeholder="Optional details..."
      :value="details"
      multiline
      :disabled="disabled"
    />
  </v-form>
</template>
      
<script>
import textInput from "@/qux-common/qux22/components/molecules/input";

export default {
  name: "CommitData",
  components: {
    textInput,
  },
  props: {
    title: {
      type: String,
    },
    details: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
      
<style lang="scss" scoped>
.commit-data {
  display: flex;
  flex-direction: column;
  gap: $qvo-spacing-24;
}
</style>